import { z } from 'zod'
import { CurrencyDto } from './CurrencyDto'
import { countryCodeEnum } from '@gap/utils/country/countryList'

export const countryCodeEnumSchema = z.enum(countryCodeEnum)
export type CountryCodeEnum = z.output<typeof countryCodeEnumSchema>

export interface CountryDto {
   code: CountryCodeEnum
   name: string
   defaultCurrency: CurrencyDto
}
